export enum ErrorMessages {
  IncorrectUserRole = 'User does not have the required user role',
  UserNotFound = 'User not found',
}
